<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">GOSSIP</span>
          <small class="d-block">DIRECTORY</small>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link " routerLink="/" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link active" routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/platforms" (click)="isNavOpen = false">Platforms</a></li>
          <li class="nav-item">
            <a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Your Card</a>
          </li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Harships Incentives</a></li>
        </ul>
      </div>
      <div class="d-none d-md-flex align-items-center gap-2">
        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">LOGIN</a>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
        </a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ PACKAGES HERO ============ -->
<section class="pkg-hero">
  <div class="container">
    <p class="pkg-tagline">YOUR VOICE. YOUR COMMUNITY. POWERED BY <span class="text-pink">UMYO</span>.</p>

    <div class="row align-items-center pkg-hero-row">
      <div class="col-lg-5">
        <h1 class="pkg-hero-title">
          CHOOSE YOUR PACKAGE.<br>
          <span class="text-pink">CONNECT. BUILD.</span><br>
          BE DISCOVERED.
        </h1>
        <p class="pkg-hero-desc">
          Affordable digital membership designed for creators, influencers, professionals, entrepreneurs, community members, and businesses to build their presence, make connections, and increase visibility throughout the UMYO Gossip ecosystem.
        </p>
        <a href="/?authTab=register#register" class="btn btn-pink">
          REGISTER NOW
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
          </svg>
        </a>
      </div>

      <div class="col-lg-7">
        <div class="pkg-hero-image">
          <img src="assets/images/packages-hero.png" alt="UMYO Gossip community members" onerror="this.parentElement.style.display='none'">
        </div>
      </div>
    </div>

    <div class="pkg-feature-strip">
      <div class="pkg-feature-item">
        <span class="pkg-feature-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <div>
          <strong>ONE COMMUNITY</strong>
          <span>MILLIONS OF CONNECTIONS</span>
        </div>
      </div>

      <div class="pkg-feature-item">
        <span class="pkg-feature-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z"/>
          </svg>
        </span>
        <div>
          <strong>BUILD YOUR BRAND</strong>
          <span>GROW YOUR NETWORK, GET DISCOVERED</span>
        </div>
      </div>

      <div class="pkg-feature-item">
        <span class="pkg-feature-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 17l6-6 4 4 8-8"/><path d="M17 7h4v4"/>
          </svg>
        </span>
        <div>
          <strong>MORE VISIBILITY</strong>
          <span>MORE OPPORTUNITIES, MORE IMPACT</span>
        </div>
      </div>
    </div>

  </div>
</section>

<!-- ============ MEMBER PACKAGES ============ -->
<section class="pkg-packages-section">
  <div class="container">

    <div class="pkg-divider">
      <span class="line"></span>
      <h2>MEMBER PACKAGES</h2>
      <span class="line"></span>
    </div>

    <div class="pkg-tier-grid">

      <!-- STARTER -->
      <div class="pkg-tier-card pkg-tier-purple">
        <div class="pkg-tier-header"><span>STARTER</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">$2.54</h3>
          <p class="pkg-tier-desc">A simple way to establish your digital presence in the community.</p>

          <ul class="pkg-tier-list">
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
              Personal Digital Profile
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M8 4v5"/></svg>
              Directory Listing
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              Connect &amp; Network
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>
              Exclusive Community Access
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/></svg>
              Updates &amp; Announcements
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 15-5-5L5 20"/></svg>
              1 Image
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20"/></svg>
              1 Digital Card
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41 12 22l-9-9V4a1 1 0 0 1 1-1h9l9 9a2 2 0 0 1 0 2.41Z"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor" stroke="none"/></svg>
              Social Media Links
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM19 14h2v2h-2zM14 19h2v2h-2zM19 19h2v2h-2z"/></svg>
              QR Code
            </li>
          </ul>

          <div class="pkg-tier-benefit">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">DIRECTORY BENEFIT</strong>
              <span class="pkg-benefit-title">STANDARD LISTING</span>
              <p>Be visible and searchable inside the directory.</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn">SELECT PACKAGE</a>
        </div>
      </div>

      <!-- CONNECT -->
      <div class="pkg-tier-card pkg-tier-pink">
        <div class="pkg-tier-header"><span>CONNECT</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">$5.99</h3>
          <p class="pkg-tier-desc">Build your presence and let the community know you're open to new opportunities.</p>

          <ul class="pkg-tier-list">
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20"/></svg>
              3 Digital Cards
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 15-5-5L5 20"/></svg>
              2 Images
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="14" height="12" rx="2"/><path d="m17 10 4-3v10l-4-3"/></svg>
              1 Video
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>
              Web Links
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M8 4v5"/></svg>
              Directory Access
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              Community Networking
            </li>
          </ul>

          <div class="pkg-tier-benefit pkg-benefit-pink">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">DIRECTORY BENEFIT</strong>
              <span class="pkg-benefit-title">AVAILABLE FOR HIRE</span>
              <p>Let clients and brands know you're available for paid opportunities.</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn pkg-tier-btn-pink">SELECT PACKAGE</a>
        </div>
      </div>

      <!-- GROW -->
      <div class="pkg-tier-card pkg-tier-purple">
        <div class="pkg-tier-header"><span>GROW</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">$9.99</h3>
          <p class="pkg-tier-desc">More tools, more content, and more ways to showcase who you are.</p>

          <ul class="pkg-tier-list">
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20"/></svg>
              6 Digital Cards
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 15-5-5L5 20"/></svg>
              3 Images
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="14" height="12" rx="2"/><path d="m17 10 4-3v10l-4-3"/></svg>
              2 Videos
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>
              Web Links
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M8 4v5"/></svg>
              Directory Access
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              Community Networking
            </li>
          </ul>

          <div class="pkg-tier-benefit">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">DIRECTORY BENEFIT</strong>
              <span class="pkg-benefit-title">STANDARD LISTING</span>
              <p>Build a larger profile while remaining searchable in the directory.</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn">SELECT PACKAGE</a>
        </div>
      </div>

      <!-- PRO -->
      <div class="pkg-tier-card pkg-tier-pink">
        <div class="pkg-tier-header"><span>PRO</span></div>
        <div class="pkg-tier-body">
          <h3 class="pkg-tier-price">$19.99</h3>
          <p class="pkg-tier-desc">Maximum visibility, credibility, and exposure in the directory.</p>

          <ul class="pkg-tier-list">
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20"/></svg>
              9 Digital Cards
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="m21 15-5-5L5 20"/></svg>
              Unlimited Images
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="14" height="12" rx="2"/><path d="m17 10 4-3v10l-4-3"/></svg>
              3 Videos
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1"/><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1"/></svg>
              Web Links
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18M8 4v5"/></svg>
              Directory Access
            </li>
            <li>
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              Community Networking
            </li>
          </ul>

          <div class="pkg-tier-benefit pkg-benefit-green">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m9 12 2 2 4-4"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-title">VERIFIED MEMBER</strong>
              <p>Receive a verified status badge that establishes trust and credibility.</p>
            </div>
          </div>

          <div class="pkg-tier-benefit pkg-benefit-gold">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 2.6 6.6L21 9l-5.2 4.3L17.5 21 12 17.3 6.5 21l1.7-7.7L3 9l6.4-.4Z"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-title">FEATURED MEMBER</strong>
              <p>Get featured placement in the Featured Members section of the directory.</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-tier-btn pkg-tier-btn-pink">SELECT PACKAGE</a>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ BUSINESS PACKAGES ============ -->
<section class="pkg-biz-section">
  <div class="container">

    <div class="pkg-divider">
      <span class="line"></span>
      <h2>BUSINESS PACKAGES</h2>
      <span class="line"></span>
    </div>

    <div class="pkg-biz-grid">

      <!-- BUSINESS -->
      <div class="pkg-biz-card">
        <div class="pkg-biz-header">
          <span class="pkg-biz-icon">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="7" width="18" height="12" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
          </span>
          <div>
            <strong>BUSINESS</strong>
            <span class="pkg-biz-tag">ACCEPTING CLIENTS</span>
          </div>
        </div>

        <div class="pkg-biz-body">
          <h3 class="pkg-biz-price">$49.99 <span>&amp; UP</span></h3>
          <p class="pkg-biz-desc">Put your business in front of the community and make it easier for customers and clients to discover what you offer.</p>

          <div class="pkg-biz-list-grid">
            <ul>
              <li>Business Digital Profile</li>
              <li>Business Directory Listing</li>
              <li>Promote Products &amp; Services</li>
              <li>Analytics &amp; Services</li>
            </ul>
            <ul>
              <li>25 Digital Cards</li>
              <li>6 Videos</li>
              <li>Unlimited Images</li>
              <li>Social Media &amp; Web Links</li>
              <li>QR Code</li>
            </ul>
          </div>

          <div class="pkg-tier-benefit pkg-benefit-green">
            <span class="pkg-benefit-icon">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg>
            </span>
            <div>
              <strong class="pkg-benefit-label">DIRECTORY BENEFIT</strong>
              <span class="pkg-benefit-title">ACCEPTING CLIENTS</span>
              <p>Let members know your business is currently accepting new customers, clients, or projects.</p>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-biz-btn">REGISTER YOUR BUSINESS</a>
        </div>
      </div>

      <!-- BUSINESS PRO -->
      <div class="pkg-biz-card pkg-biz-pro">
        <span class="pkg-best-ribbon">BEST VALUE</span>

        <div class="pkg-biz-header pkg-biz-header-gold">
          <span class="pkg-biz-icon pkg-biz-icon-gold">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="m2 8 4 3 6-7 6 7 4-3-2 11H4L2 8Z"/>
            </svg>
          </span>
          <div>
            <strong>BUSINESS PRO</strong>
            <span class="pkg-biz-tag pkg-biz-tag-gold">MAXIMUM VISIBILITY</span>
          </div>
        </div>

        <div class="pkg-biz-body">
          <h3 class="pkg-biz-price pkg-biz-price-gold">$109.99</h3>
          <p class="pkg-biz-desc">Maximum visibility for businesses that want to stand out, attract customers, promote offers, and receive featured placement.</p>

          <div class="pkg-biz-pro-inner">
            <div class="pkg-biz-pro-left">
              <p class="pkg-biz-plus-label">EVERYTHING IN BUSINESS, PLUS:</p>
              <div class="pkg-biz-list-grid">
                <ul>
                  <li>Unlimited Images</li>
                  <li>6 Videos</li>
                  <li>Advanced Analytics</li>
                  <li>Social Media &amp; Web Links</li>
                  <li>QR Code</li>
                </ul>
                <ul>
                  <li>Enhanced Business Presence</li>
                  <li>Priority Directory Placement</li>
                  <li>Custom Branding Opportunities</li>
                  <li>25 Digital Cards</li>
                </ul>
              </div>
            </div>

            <div class="pkg-biz-pro-right">
              <div class="pkg-pro-side-item pkg-benefit-green">
                <span class="pkg-benefit-icon">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg>
                </span>
                <div>
                  <strong>ACCEPTING CLIENTS</strong>
                  <p>Show customers your business is ready to serve.</p>
                </div>
              </div>

              <div class="pkg-pro-side-item pkg-benefit-purple">
                <span class="pkg-benefit-icon">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="7" r="3"/><circle cx="17" cy="17" r="3"/><path d="m19 5-14 14"/></svg>
                </span>
                <div>
                  <strong>OFFERS DISCOUNTS</strong>
                  <p>Promote special discounts, offers, incentives, and savings to community members.</p>
                </div>
              </div>

              <div class="pkg-pro-side-item pkg-benefit-gold">
                <span class="pkg-benefit-icon">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 2.6 6.6L21 9l-5.2 4.3L17.5 21 12 17.3 6.5 21l1.7-7.7L3 9l6.4-.4Z"/></svg>
                </span>
                <div>
                  <strong>FEATURED BUSINESS</strong>
                  <p>Receive featured placement in the Featured Businesses section of the directory.</p>
                </div>
              </div>
            </div>
          </div>

          <a href="/?authTab=register#register" class="btn pkg-biz-btn pkg-biz-btn-pink">SELECT BUSINESS PRO</a>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ GET DISCOVERED YOUR WAY + ALL PACKAGES INCLUDE ============ -->
<section class="pkg-discover-section">
  <div class="container">
    <div class="row gx-4">

      <div class="col-lg-7 mb-4 mb-lg-0">
        <div class="pkg-discover-card">
          <h3 class="pkg-discover-title">GET DISCOVERED <span class="text-pink">YOUR WAY</span></h3>
          <p class="pkg-discover-sub">Your package determines the additional visibility features available for your profile inside the UMYO Gossip Directory.</p>

          <table class="pkg-discover-table">
            <thead>
              <tr><th>DIRECTORY FEATURE</th><th>INCLUDED WITH</th></tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="pkg-table-icon"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg></span>Standard Listing</td>
                <td>Starter</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon pink"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg></span>Available for Hire</td>
                <td>Connect</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/></svg></span>Standard Listing</td>
                <td>Grow</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon green"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m9 12 2 2 4-4"/></svg></span>Verified Member</td>
                <td>Pro</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon gold"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 2.6 6.6L21 9l-5.2 4.3L17.5 21 12 17.3 6.5 21l1.7-7.7L3 9l6.4-.4Z"/></svg></span>Featured Member</td>
                <td>Pro</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon green"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m11 17 2 2 4-4"/><path d="M7 13a4 4 0 1 1 4-4"/><path d="M18 16.5V13a2 2 0 0 0-4 0v1"/></svg></span>Accepting Clients</td>
                <td>Business</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon purple"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="7" r="3"/><circle cx="17" cy="17" r="3"/><path d="m19 5-14 14"/></svg></span>Offers Discounts</td>
                <td>Business Pro</td>
              </tr>
              <tr>
                <td><span class="pkg-table-icon gold"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 2.6 6.6L21 9l-5.2 4.3L17.5 21 12 17.3 6.5 21l1.7-7.7L3 9l6.4-.4Z"/></svg></span>Featured Business</td>
                <td>Business Pro</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="pkg-include-card">
          <h3 class="pkg-include-title">ALL PACKAGES <span class="text-pink">INCLUDE</span></h3>
          <p class="pkg-include-sub">Every package comes with powerful tools and support to help you grow in the UMYO Gossip ecosystem.</p>

          <div class="pkg-include-grid">
            <div class="pkg-include-item">
              <span class="pkg-include-icon">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s7-3.5 7-9V5l-7-3-7 3v8c0 5.5 7 9 7 9Z"/></svg>
              </span>
              <strong>SECURE COMMUNITY ACCESS</strong>
              <p>Connect within a safe and secure digital community.</p>
            </div>

            <div class="pkg-include-item">
              <span class="pkg-include-icon">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11v3a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1Z"/><path d="M16 8a5 5 0 0 1 0 8"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>
              </span>
              <strong>COMMUNITY NEWS &amp; UPDATES</strong>
              <p>Stay informed about opportunities, events, announcements, and resources.</p>
            </div>

            <div class="pkg-include-item">
              <span class="pkg-include-icon">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1v-6h3Z"/><path d="M3 19a2 2 0 0 0 2 2h1v-6H3Z"/></svg>
              </span>
              <strong>MEMBER SUPPORT</strong>
              <p>Get the help you need as you build your presence.</p>
            </div>

            <div class="pkg-include-item">
              <span class="pkg-include-icon">
                <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M10 18h4"/></svg>
              </span>
              <strong>MOBILE-FRIENDLY EXPERIENCE</strong>
              <p>Access your profile, directory, and community anytime, anywhere.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ ECOSYSTEM BANNER ============ -->
<section class="pkg-cta-section">
  <div class="container">
    <div class="pkg-ecosystem-banner">

      <div class="pkg-ecosystem-left">
        <span class="pkg-ecosystem-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <div>
          <h4>YOUR MEMBERSHIP HELPS BUILD <span class="text-pink">THE ECOSYSTEM.</span></h4>
          <p class="mb-0">Every registration helps strengthen the UMYO Gossip digital ecosystem, expand our community, support our members, and build technology designed for us.</p>
        </div>
      </div>

      <div class="pkg-ecosystem-mid">
        <p>More connections.<br>More opportunities.<br>A stronger community.</p>
      </div>

      <div class="pkg-ecosystem-cta">
        <h4>JOIN TODAY.<br>CONNECT TODAY.<br>GROW WITH US.</h4>
        <a href="/?authTab=register#register" class="btn pkg-ecosystem-btn">CHOOSE YOUR PACKAGE</a>
      </div>

    </div>
  </div>
</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Gossip" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">GOSSIP</span></div>
        </div>
        <small class="d-block pkg-footer-muted">YOUR VOICE. YOUR COMMUNITY.<br>POWERED BY UMYO.</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">QUICK LINKS</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/platforms">Platforms</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">RESOURCES</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="/how-to">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">LET'S CONNECT</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>© 2026 UMYO Gossip Directory. All Rights Reserved.</small>
    </div>
  </div>
</footer>